import to from 'await-to-js'
import AkeMessage from '@/utils/plugins/message'

export async function awaitTo(promise, errorExt) {
  const [err, data] = await to(promise, errorExt)
  if (err) {
    console.log(err)
    if (errorExt) {
      Object.assign(err, errorExt)
    }
    const message = err?.message
    if (message) {
      AkeMessage.error(message)
    }
    return [err, undefined]
  }

  return [null, data]
}
